import {
  getCosToken,
  putObjectWithCosToken,
  type PutObjectWithCosTokenResult,
} from "./cos-token";

/** 音频上传结果 */
export type CosUploadVoiceFileResult = PutObjectWithCosTokenResult;

export interface CosUploadVoiceFileOptions {
  onProgress?: (progress: number) => void;
}

/**
 * 音频场景：使用临时密钥将音频直传 COS（voice 场景）
 */
export const cosUploadVoiceFile = async (
  file: File,
  options?: CosUploadVoiceFileOptions
): Promise<CosUploadVoiceFileResult> => {
  const token = await getCosToken({ scene: "voice" });
  return putObjectWithCosToken(token, {
    file,
    onProgress: options?.onProgress,
  });
};
